import React from 'react'

function Contact() {
  return (
    <div className="home-container">
      <div className="home-header">
        <h1>KONTAKT</h1>
        </div>

        <section>
          <br />
          <p>
            <strong>
              Kontaktieren Sie uns:
            </strong>
          </p>
          <br />
          <p>
            <strong>Dr. Ernst Leitgeb</strong><br />
            Institutsleiter<br />
            Institut für Waldökologie und Boden <br />
            BFW
          </p>
          <p>
            <strong>T</strong> +43-1-878 38 – 1201<br />
            
            <a href="mailto:ernst.leitgeb@bfw.gv.at">
              ernst.leitgeb@bfw.gv.at
            </a>
          </p>
          <br />
          <p>
            <strong>Mag. Karl Gartner</strong><br />
             Stellv. Abteilungsleiter<br />
             Abteilung Standort und Vegetation<br />
             Institut für Waldökologie und Boden<br />
             BFW<br />
            <strong>T </strong> +43-1-878 38 – 1344<br />
            <strong>E-Mail:</strong>{' '}
            <a href="mailto:karl.gartner@bfw.gv.at">karl.gartner@bfw.gv.at</a>
          </p>
      </section>
    </div>
  )
}

export default Contact